var map = {
	"./健身環大冒險/1.jpg": "e799",
	"./健身環大冒險/2.jpg": "eade",
	"./健身環大冒險/3.jpg": "af7f",
	"./健身環大冒險/4.jpg": "6b88",
	"./瓦利歐製造/1.jpg": "6ec2",
	"./瓦利歐製造/2.jpg": "f539",
	"./瓦利歐製造/3.jpg": "7189",
	"./瓦利歐製造/4.jpg": "7ee8",
	"./聖劍傳說-3/1.jpg": "05e7",
	"./聖劍傳說-3/2.jpg": "1f95",
	"./聖劍傳說-3/3.jpg": "b31c",
	"./聖劍傳說-3/4.jpg": "04eb",
	"./薩爾達傳說-曠野之息/1.jpg": "a276",
	"./薩爾達傳說-曠野之息/2.jpg": "e6fb",
	"./薩爾達傳說-曠野之息/3.jpg": "7731",
	"./薩爾達傳說-曠野之息/4.jpg": "9a8d",
	"./超級瑪利歐-奧德賽/1.jpg": "fcca",
	"./超級瑪利歐-奧德賽/2.jpg": "c7dc",
	"./超級瑪利歐-奧德賽/3.jpg": "8e84",
	"./超級瑪利歐-奧德賽/4.jpg": "7e5d",
	"./路易吉洋樓-3/1.jpg": "5948",
	"./路易吉洋樓-3/2.jpg": "f777",
	"./路易吉洋樓-3/3.jpg": "4e37",
	"./路易吉洋樓-3/4.jpg": "0ab2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9308";